<template>
  <div>
    <div class="opd-card" id="printArea">

      <!-- Header -->
      <div class="title-details" v-if="IsNusingHome">

        <div class="logo">
          <img v-if="hospital.logo" :src="hospital.logo">
        </div>
        <div class="Nursing-home-hospital-details">
          <h2>
            {{ hospital.name }}
          </h2>
          <p>Hawai Nagar, Road no. A3, Birsa Chowk, Ranchi </p>
          <p>
            <span style="margin-right: 20px;">
              <strong>Contact:</strong> 97714 40818, 99397 35164
            </span>
            <span>
              <strong>GST:</strong> 20ATMPS8605A1ZX</span>
          </p>
          <p style="text-align: left;"><span><strong>Mail:</strong>{{
            hospital.hospitalemail }}</span></p>
        </div>
        <div class="opd-no" v-if="tenantSetup && tenantSetup.displaySerialNumber">
            <p>OPD NO.</p>
            <span>{{ serialNumber }}</span>
        </div>
      </div>
       <div :class="tenantSetup && tenantSetup.displaySerialNumber ? 'newheader' : 'header'" v-else>
        <div class="logo">
          <img :src="hospital.logo" />
        </div>
        <div  :class="tenantSetup && tenantSetup.displaySerialNumber ? 'newtitle-details' : 'title-details'">
          <h2>{{ hospital.name }}</h2>
          <!-- <p>{{ hospital.subTitle }}</p> -->
          <p>{{ hospital.address }}</p>
          <p>{{ hospital.contact }}</p>
        </div>
        <div class="odp-number" v-if="tenantSetup && tenantSetup.displaySerialNumber">
            <p class="opd-text">OPD NO.</p>
            <p class="opd-num">{{ serialNumber }}</p>
        </div>
      </div>
      <div class="opd-title">
        OPD CARD
      </div>

      <!-- Details -->
      <div class="details">
        <div class="left">
            <table style="width:100%;">            
                <tr class="row">
                    <td class="label">UHID</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.uhid }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Name</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.name }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Age/Sex</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.ageSex }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Relation Name</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.relation }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Department</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.department || 'Not Specified' }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Doctor Name</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.doctorname }}</td>
                </tr>
            </table>
        </div>

        <div class="right">
            <table style="width:100%;">            
                <tr class="row">
                    <td class="label">Date</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.date }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Contact No.</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.mobile }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Address</td>
                    <td style="width:5px; vertical-align:top;">:</td>
                    <td>{{ patient.address }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Fees</td>
                    <td style="width:5px;">:</td>
                    <td>{{ currency}}{{ patient.fees }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Mode</td>
                    <td style="width:5px;">:</td>
                    <td>{{ capitalizeFirst(patient.panel) }}</td>
                </tr>
                <tr class="row">
                    <td class="label">Generated By</td>
                    <td style="width:5px;">:</td>
                    <td>{{ patient.generatedbyname }}</td>
                </tr>
            </table>
        </div>
      </div>

    <div class="timing">
    <span v-if="tenantSetup && tenantSetup.displayCustomOpdTimingText && tenantSetup.customOpdTimingText">
        {{ tenantSetup.customOpdTimingText }}
    </span>
    <span v-else>
        OPD TIMING: {{ hospital.timing }}
    </span>
    </div>

      <!-- Extra -->
      <div class="extra-info" v-if="showVitals">
        <div class="line-field">
         <strong>Vitals</strong>
          <div class="dotted"></div>
        </div>
        <div class="line-field" v-if="patient.vitalupdateddate">
          <strong>Vitals recorded date </strong>: {{ patient.vitalupdateddate }}
          <div class="dotted"></div>
        </div>
        <div v-if="tenantSetup && tenantSetup.displayVitalsInSingleLine">
            <div class="line-field">
                <strong>Vitals:</strong>

                <span v-if="patient.height">Height: {{ patient.height }}, </span>
                <span v-if="patient.weight">Weight: {{ patient.weight }}, </span>
                <span v-if="patient.bp">BP: {{ patient.bp }}, </span>
                <span v-if="patient.pulse">Pulse: {{ patient.pulse }}, </span>
                <span v-if="patient.temperature">Temp: {{ patient.temperature }}, </span>
                <span v-if="patient.bmi">BMI: {{ patient.bmi }}, </span>
                <span v-if="patient.o2">O2: {{ patient.o2 }}, </span>
                <span v-if="patient.respiratoryRate">RR: {{ patient.respiratoryRate }}, </span>
                <span v-if="patient.allergysumarry">Allergies: {{ patient.allergysumarry }}</span>

                <div class="dotted"></div>
            </div>
        </div>
        <div v-else>
            <div class="line-field" v-if="patient.height">    
                <strong>Height </strong>: {{ patient.height }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.weight">
                <strong>Weight </strong>: {{ patient.weight }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.bp">
                <strong>BP </strong>: {{ patient.bp }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.pulse">
                <strong>Pulse </strong>: {{ patient.pulse }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.temperature">
                <strong>Temperature </strong>: {{ patient.temperature }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.bmi">
                <strong>BMI </strong>: {{ patient.bmi }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.o2">
                <strong>O2 Saturation </strong>: {{ patient.o2 }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.respiratoryRate">
                <strong>Respiratory Rate </strong>: {{ patient.respiratoryRate }}
                <div class="dotted"></div>
            </div>

            <div class="line-field" v-if="patient.allergysumarry">
                <strong>Known Drug Allergies </strong>: {{ patient.allergysumarry }}
                <div class="dotted"></div>
            </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import rest_service from "@/api/rest_service";
export default {
  props: {
    patientData: Object,
    hospital : Object,
    opdCardSections : Array,
    tenantSetup: Object,
    serialNumber: String
  },
    data() {
        //const tenantSetupRaw = localStorage.getItem("tenantbusinesssetup");
        //const tenantSetup = tenantSetupRaw ? JSON.parse(tenantSetupRaw) : null;

        return {
            currency:"",
            // hospital: {
            //     logo: "",
            //     name: "",
            //     address: "",
            //     contact: "",
            //     timing: "MONDAY TO SATURDAY - (9:00 AM TO 04:00 PM)"
            // },
            tenantId:'',
        };
    },
    mounted() {
        //this.loadHospitalData();
        this.tenantId = localStorage.tenantid;
        if (localStorage.TenantCurrency) {
            var Currency = JSON.parse(window.localStorage.getItem("TenantCurrency"));
            if (Currency)
                this.currency = Currency.symbol;
        }
        else {
            rest_service.GetCurrency(this.tenantId).then(response => {
                var Currency = JSON.parse(window.localStorage.getItem("TenantCurrency"));
                if (Currency)
                    this.currency = Currency.symbol;
            });
        }
    },
    computed: {
        showVitals() {
            return Array.isArray(this.opdCardSections) &&
                this.opdCardSections.includes("Vitals");
        },
        patient() {
            return {
                uhid: this.patientData && this.patientData.uhid ? this.patientData.uhid : "",
                name: this.patientData && this.patientData.name ? this.patientData.name : "",
                ageSex: this.patientData && this.patientData.ageSex ? this.patientData.ageSex : "",
                relation: this.patientData && this.patientData.relation ? this.patientData.relation : "NA",
                department: this.patientData && this.patientData.department ? this.patientData.department : "",
                date: this.formatDate(this.patientData && this.patientData.date ? this.patientData.date : ""),
                mobile: this.patientData && this.patientData.mobile ? this.patientData.mobile : "",
                address: this.patientData && this.patientData.address ? this.patientData.address : "",
                fees: this.patientData && this.patientData.fees ? this.patientData.fees : 0,
                panel: this.patientData && this.patientData.panel ? this.patientData.panel : "",
                height: this.patientData && this.patientData.height ? this.patientData.height : "",
                weight: this.patientData && this.patientData.weight ? this.patientData.weight : "",
                allergysumarry: this.patientData && this.patientData.allergySummary ? this.patientData.allergySummary : "",
                bp: this.patientData && this.patientData.bp ? this.patientData.bp : "",
                pulse: this.patientData && this.patientData.pulse ? this.patientData.pulse : "",
                temperature: this.patientData && this.patientData.temperature ? this.patientData.temperature : "",
                bmi: this.patientData && this.patientData.bmi ? this.patientData.bmi : "",
                o2: this.patientData && this.patientData.o2 ? this.patientData.o2 : "",
                respiratoryRate: this.patientData && this.patientData.respiratoryRate ? this.patientData.respiratoryRate : "",
                doctorname: this.patientData && this.patientData.doctorname ? this.patientData.doctorname : "",
                generatedbyname: this.patientData && this.patientData.generatedbyname ? this.patientData.generatedbyname : "",
                vitalupdateddate: this.formatDate(this.patientData && this.patientData.vitalupdateddate ? this.patientData.vitalupdateddate : ""),
            };
        },
        IsNusingHome() {
            const data = localStorage.getItem("tenantid");
            if (data == '4ba2ca2e-6c67-4b86-ae13-109f83430140') {
                return true;
            }
            return false;
        }
    },
    methods: {
        capitalizeFirst(val) {
            if (!val) return '';
            return val.charAt(0).toUpperCase() + val.slice(1);
        },
        loadHospitalData() {
            var tenantSetupRaw = localStorage.getItem("tenantbusinesssetup");
            var tenantSetup = tenantSetupRaw ? JSON.parse(tenantSetupRaw) : null;

            this.hospital.logo = localStorage.getItem("ClicnicUrllogo") || "";
            this.hospital.name = tenantSetup ? tenantSetup.name : "";

            if (
                tenantSetup &&
                tenantSetup.location &&
                tenantSetup.location.length
            ) {
                this.hospital.address = tenantSetup.location[0].address || "";
                this.hospital.contact =tenantSetup.hospitalcontact || "";
                //this.hospital.contact =tenantSetup.location[0].clinic_contact_numbers || "";
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";

            const date = new Date(dateString);

            const day = ("0" + date.getDate()).slice(-2);
            const month = ("0" + (date.getMonth() + 1)).slice(-2);
            const year = date.getFullYear();

            let hours = date.getHours();
            const minutes = ("0" + date.getMinutes()).slice(-2);

            const ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12;

            return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
        }
    }
};
</script>
<style scoped>
body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 20px;
    background: #f5f5f5;
}

.opd-card {
    max-width: 900px;
    margin: auto;
    background: #fff;
    padding: 20px;
    border: 1px solid #ccc;
}

.header {
    text-align: center;
    border-bottom: 1px solid #000;
    padding-bottom: 10px;
	display:inline-block;
	width:100%;
}
.header .logo {
    float: left;
}
.header .logo img{width:150px; height:125px;}
.header .title-details {
    float: left;
}

.header h2 {
    margin: 5px 0;
}

.header p {
    margin: 3px 0;
    font-size: 14px;
}

.opd-title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    margin: 15px 0;
    border-bottom: 1px solid #000;
    padding-bottom: 5px;
}

.details {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.left, .right {
    width: 48%;
}

.row {
    margin-bottom: 8px;
    font-size: 14px;
}

.label {
    font-weight: bold;
    display: inline-block;
    width: 140px;
    position:relative;
    padding-right:10px;
    margin-bottom:5px;
}

.timing {
    margin-top: 15px;
    font-weight: bold;
    border-top: 1px solid #000;
    padding-top: 10px;
}

.extra-info {
    margin-top: 30px;
    width: 50%;
   
}

.line-field {
    margin-bottom: 15px;
}

.dotted {
    border-bottom: 1px dotted #000;
    height: 20px;
}
/* Input Section */
.extra-info  .input-section {
    margin-top: 30px;
   
}

.extra-info  .form-group {
    margin-bottom: 15px;
	position:relative;
}
.extra-info  .form-group .container-comm {
    position: relative;
}
.extra-info  .form-group .container-comm input {
    line-height: 40px;
    display: block;
    width: 100%!important;
    background: #fff!important;
    height: 40px!important;
    border: none!important;
    border: 1px solid #a5a5a5!important;
    padding-left: 15px;
    font-size: 14px!important;
    font-weight: 400!important;
    color: #1d1d1d!important;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    border-radius: 0!important;
}
.extra-info  .form-group .container-comm label {
    position: absolute;
    top: 10px;
    left: 20px;
    pointer-events: none;
    color: #606060;
    font-size: 14px;
    font-weight: 300!important;
    font-weight: lighter;
    -webkit-transition: .2s cubic-bezier(.4,0,.2,1);
    transition: .2s cubic-bezier(.4,0,.2,1);
}
.extra-info  .form-group .container-comm label {
    text-align: left;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
}
.extra-info  .form-group .container-comm label{
    width: 100%;
    display: block;
}
table {
  border-collapse: separate;
  border-spacing : 10px
}
table td{
    vertical-align:top;
}
.title-details>div>img {
    max-width: 160px;
}
.title-details {
    grid-gap: 34px !important;
}
.title-details h2 {
    font-size: 45px !important;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 0px;
    line-height: 1.1;
}
.title-details p {
    margin: 0 0 5px;
    margin: 0 0 5px;
    font-size: 16.5px;
    font-weight: 500;
    line-height: 1.3;
    margin-bottom: 6px;
}
.Nursing-home-hospital-details p:first-of-type{
    font-size: 23px;
}
.Nursing-home-hospital-details p:nth-of-type(2) {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.Nursing-home-hospital-details p:nth-of-type(3) {
  display: flex;
  justify-content: space-between;
}
</style>